<template>
  <div>
    <page-intro>
      <template v-slot:heading>Тарифы</template>
      <template v-slot:controls>
        <div class="flex-column flex-y-start">
          <label class="mb-4">Период оплаты</label>
          <el-select
            v-model="choosenTerm"
            :disabled="$mip('getPlans')">
            <el-option
              v-for="term in plansInfo.terms"
              :key="term.term"
              :label="term.termLabel"
              :value="term.term" />
          </el-select>
        </div>
      </template>
    </page-intro>

    <div class="stack-md">
      <div v-loading="$mip('getPlans')" class="widget">
        <div class="widget__body p-0">
          <div class="row no-gutters text-center text-xs">
            <div v-for="plan in plansInfo.plans" :key="plan.id" class="col-md-4 border-right pos-rel flex-column">
              <div v-if="plan.isHit" class="plan__hit-mark" v-html="require('@/assets/img/icons/hit-mark.svg')" />
              <div class="stack-24 px-24 py-28 plan__description">
                <h3 class="h2 text-primary">{{ plan.name }}</h3>
                <div class="plan__divider" />
                <div>
                  <span class="h3 text-primary">{{ formatNumber(plan.diskSpace, 'storage') }}</span> на диске
                </div>
                <div>{{ formatNumber(plan.perUserPrice, 'currency') }} / доп. пользователь</div>
                <div v-for="option in plan.options" :key="option.title">
                  <div class="mb-8 text-bold">{{ option.title }}:</div>
                  <div>{{ option.status }}</div>
                </div>
              </div>
              <div class="plan__action-block bg-primary-lightish p-24 pt-28">
                <div class="text-primary text-medium mb-24">
                  <span class="h1">{{ formatNumber(plan.terms[choosenTerm] && plan.terms[choosenTerm].price, 'currency') }}</span> / мес.
                </div>
                <el-button
                  v-if="plan.isCurrent" class="w-100 current-plan" disabled
                  type="success">
                  Текущий <i class="el-icon-check"></i>
                </el-button>
                <el-button
                  v-else
                  :loading="$mip('activatePlan')"
                  class="w-100"
                  type="primary"
                  :disabled="!$store.state.user.accInfo.isAdmin"
                  @click="selectPlan(plan)">
                  Выбрать
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="widget">
        <div class="widget__head">
          <div class="widget__title">Для всех тарифов</div>
        </div>
        <div class="widget__body flex flex-x-center">
          <div v-for="(advantage, i) in advantages" :key="i" class="advantage p-8 flex-nowrap">
            <!-- <div class="advantage__icon text-center" :class="advantage.icon" /> -->
            <div class="advantage__icon mr-12 pt-8" v-html="require('@/assets/img/icons/check.svg')"></div>
            <div class="advantage__description">
              {{ advantage.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PageIntro from '@/components/PageIntro.vue'
  import { formatNumber } from '@/utils'

  export default {
    components: {
      PageIntro
    },

    data() {
      return {
        choosenTerm: '12',
        advantages: [
          {
            icon: 'el-icon-star-on',
            description: 'Максимальное количество пользователей без ограничений.'
          },
          {
            icon: 'el-icon-star-on',
            description: 'Количество информационных баз (и конфигураций) нет ограничений (в рамках дискового пространства).'
          },
          {
            icon: 'el-icon-star-on',
            description: 'Возможность изменения информационной базы допускается.'
          },
          {
            icon: 'el-icon-star-on',
            description: 'Сопровождение типовых информационных баз без ограничений и дополнительной оплаты'
          },
          {
            icon: 'el-icon-star-on',
            description: 'Линия консультация по техническим вопросам 24/7 количество консультаций неограниченно.'
          }
        ],
        plansInfo: {}
      }
    },

    async created() {
      this.plansInfo = (await this.$http.getPlans()).data
    },

    methods: {
      formatNumber,
      selectPlan({ name, id }) {
        this.$confirm(`Вы выбрали тариф ${name}`, '', {
          confirmButtonText: 'Подтвердить',
          type: 'info'
        }).then(async () => {
          await this.$http.activatePlan(id)

          this.plansInfo.plans.forEach(plan => {
            plan.isCurrent = plan.id === id
          })

          this.$store.dispatch('setAccInfo')

          this.$notify({
            title: 'Выбор тарифа',
            message: 'Ваша заявка принята. С вами свяжется менеджер',
            type: 'success'
          })
        }).catch(() => {})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .plan__divider {
    width: 60px;
    height: 2px;
    margin-left: auto;
    margin-right: auto;
    background: $primary-color;
  }

  .plan__hit-mark {
    width: 27px;
    height: 59px;
    position: absolute;
    top: -3px;
    right: 12px;
  }

  .plan__description {
    flex-grow: 1;
  }

  .current-plan {
    cursor: default;
  }

  .advantage {
    width: 50%;
    min-width: 250px;
  }

  .advantage__icon {
    // font-size: 65px;
    width: 18px;
    height: 15px;
  }

  .advantage__description {
    min-width: 0;
    flex-shrink: 1;
  }
</style>